const determineBase = () => {
  if (process.env.REACT_APP_MOTHERSHIP_BASEURL) {
    return process.env.REACT_APP_MOTHERSHIP_BASEURL;
  }

  if (process.env.REACT_APP_ACP_ENV === "prod") {
    return "https://ops.acp-usa.org";
  }

  return "https://ops.qa.acp-usa.org";
};

export default {
  baseUrl: determineBase()
};
